(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
    if (!customElements.get('copy-link')) {
        customElements.define(
            'copy-link',
            class extends HTMLElement {
                connectedCallback() {
                    this.button = this.querySelector('[data-copy-link]');
                    this.status = this.querySelector('[data-copy-status]');
                    if (!this.button || !navigator.clipboard?.writeText) return;

                    this.onClick = this.onClick.bind(this);
                    this.button.hidden = false;
                    this.button.addEventListener('click', this.onClick);
                }

                disconnectedCallback() {
                    this.button?.removeEventListener('click', this.onClick);
                    clearTimeout(this.timer);
                }

                async onClick() {
                    try {
                        await navigator.clipboard.writeText(this.dataset.url || location.href);
                        this.show('done', this.dataset.copied);
                    } catch {
                        this.show('failed', this.dataset.failed);
                    }
                }

                show(state, message) {
                    this.setAttribute('data-copied-state', state);
                    this.status.textContent = message || '';
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.removeAttribute('data-copied-state');
                        this.status.textContent = '';
                    }, 4000);
                }
            },
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manuals-page"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('manual-finder')) {
        customElements.define(
            'manual-finder',
            class extends HTMLElement {
                connectedCallback() {
                    this.tools = this.querySelector('[data-manual-tools]');
                    this.input = this.querySelector('[data-manual-search]');
                    this.status = this.querySelector('[data-manual-status]');
                    this.empty = this.querySelector('[data-manual-empty]');
                    if (!this.tools || !this.input) return;

                    this.onInput = this.onInput.bind(this);
                    this.onClick = this.onClick.bind(this);
                    this.tools.hidden = false;
                    this.input.addEventListener('input', this.onInput);
                    this.tools.addEventListener('click', this.onClick);

                    const query = new URLSearchParams(window.location.search).get('q');
                    if (query) {
                        this.input.value = query;
                        this.apply();
                    }
                }

                disconnectedCallback() {
                    this.input?.removeEventListener('input', this.onInput);
                    this.tools?.removeEventListener('click', this.onClick);
                    clearTimeout(this.timer);
                }

                onInput() {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => this.apply(), 120);
                }

                onClick(event) {
                    const chip = event.target.closest('[data-manual-filter]');
                    if (!chip) return;
                    this.querySelectorAll('[data-manual-filter]').forEach((button) => {
                        button.setAttribute('aria-pressed', String(button === chip));
                    });
                    this.dataset.filter = chip.dataset.manualFilter;
                    this.apply();
                }

                // "20.000", "20 000" and "20000" are the same capacity.
                normalise(text) {
                    return (text || '')
                        .toLowerCase()
                        .replace(/(\d)[.\s](?=\d{3}(?!\d))/g, '$1')
                        .replace(/\s+/g, ' ')
                        .trim();
                }

                apply() {
                    const words = this.normalise(this.input.value).split(' ').filter(Boolean);
                    const filter = this.dataset.filter || '';
                    let total = 0;

                    this.querySelectorAll('[data-manual-group]').forEach((group) => {
                        const inFilter = !filter || group.dataset.manualGroup === filter;
                        let groupHits = 0;

                        group.querySelectorAll('[data-manual-item]').forEach((item) => {
                            const haystack = item.dataset.normalised || this.normalise(item.dataset.search);
                            item.dataset.normalised = haystack;
                            const hit = inFilter && words.every((word) => haystack.includes(word));
                            item.hidden = !hit;
                            if (hit) groupHits += 1;
                        });

                        const older = group.querySelector('[data-manual-older]');
                        if (older) {
                            const olderHits = older.querySelectorAll('[data-manual-item]:not([hidden])').length;
                            older.hidden = olderHits === 0;
                            const count = older.querySelector('[data-manual-older-count]');
                            if (count) count.textContent = '(' + olderHits + ')';
                            // Open the older models while searching, and close them
                            // again afterwards only if the search opened them.
                            if (words.length && olderHits) {
                                if (!older.open) older.dataset.openedBySearch = '';
                                older.open = true;
                            } else if (!words.length && older.hasAttribute('data-opened-by-search')) {
                                older.open = false;
                                older.removeAttribute('data-opened-by-search');
                            }
                        }

                        const cards = group.querySelector('ul[role="list"]');
                        if (cards && cards.parentElement === group) {
                            cards.hidden = cards.querySelectorAll('[data-manual-item]:not([hidden])').length === 0;
                        }
                        group.hidden = groupHits === 0;
                        total += groupHits;
                    });

                    if (this.empty) this.empty.hidden = total > 0;
                    if (this.status) {
                        const template = total === 1 ? this.dataset.countOne : this.dataset.countOther;
                        this.status.textContent = (template || '').replace('[count]', total);
                    }
                }
            },
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('comparison-table')) {
        customElements.define(
            'comparison-table',
            class extends HTMLElement {
                connectedCallback() {
                    // The scroll hint only makes sense while the table is wider
                    // than its frame, which depends on the number of products.
                    this.scroller = this.querySelector('[data-comparison-scroll]');
                    if (this.scroller) {
                        this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
                        this.resizeObserver.observe(this.scroller);
                    }

                    // Colour swatches swap which panel of a column is shown. Every
                    // panel is rendered by the server, so this only toggles hidden.
                    this.onClick = this.onClick.bind(this);
                    this.addEventListener('click', this.onClick);

                    this.cartAttribute = this.dataset.cartAttribute || '';
                    this.cartNote = this.dataset.cartNote || '';
                    if (!this.cartAttribute && !this.cartNote) return;

                    // The theme's <add-to-cart> sets data-loading while its request
                    // runs. Marking the cart only after it is removed keeps the two
                    // requests apart, so a first visit never ends up with two carts.
                    this.onMutation = this.onMutation.bind(this);
                    this.mutationObserver = new MutationObserver(this.onMutation);
                    this.mutationObserver.observe(this, {
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['data-loading'],
                        attributeOldValue: true,
                    });
                }

                disconnectedCallback() {
                    this.removeEventListener('click', this.onClick);
                    this.resizeObserver?.disconnect();
                    this.mutationObserver?.disconnect();
                }

                onClick(event) {
                    const swatch = event.target.closest('[data-colour-target]');
                    if (!swatch || !this.contains(swatch)) return;

                    const group = swatch.dataset.colourGroup;
                    const key = swatch.dataset.colourTarget;
                    this.querySelectorAll(`[data-colour-group="${CSS.escape(group)}"][data-colour-key]`).forEach((element) => {
                        element.hidden = element.dataset.colourKey !== key;
                    });

                    // The clicked swatch has just been hidden with its panel, so focus
                    // moves to the same colour in the panel that is now shown.
                    this.querySelector(
                        `[data-colour-key="${CSS.escape(key)}"]:not([hidden]) [data-colour-target="${CSS.escape(key)}"]`,
                    )?.focus();
                }

                updateOverflow() {
                    const overflowing = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
                    this.toggleAttribute('data-overflowing', overflowing);
                }

                onMutation(records) {
                    const finished = records.some(
                        (record) =>
                            record.target.localName === 'add-to-cart' &&
                            record.oldValue !== null &&
                            !record.target.hasAttribute('data-loading'),
                    );
                    if (finished) this.markCart();
                }

                async markCart() {
                    const root = window.Shopify?.routes?.root || '/';
                    try {
                        const cart = await (await fetch(`${root}cart.js`)).json();
                        // An empty cart here means the add landed elsewhere; marking
                        // it would only create a second, empty cart.
                        if (!cart.item_count) return;
                        const update = {};
                        if (this.cartAttribute) update.attributes = { [this.cartAttribute]: 'yes' };
                        if (this.cartNote) {
                            const note = cart.note || '';
                            if (!note.includes(this.cartNote)) {
                                update.note = note ? `${note} | ${this.cartNote}` : this.cartNote;
                            }
                        }
                        if (!update.attributes && update.note === undefined) return;

                        await fetch(`${root}cart/update.js`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                            body: JSON.stringify(update),
                        });
                    } catch {
                        // Marking the cart must never get in the way of the purchase.
                    }
                }
            },
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('reviews-reveal')) {
        customElements.define(
            'reviews-reveal',
            class extends HTMLElement {
                connectedCallback() {
                    this.button = this.querySelector('[data-reviews-toggle]');
                    this.panel = this.querySelector('[data-reviews-panel]');
                    // The theme's own summary and first reviews, in the same
                    // section. Judge.me's widget starts with the same reviews,
                    // so it replaces them rather than repeating them.
                    this.staticReviews = this.closest('.container')?.querySelector('[data-reviews-static]');
                    if (!this.button || !this.panel) return;

                    // Any app block counts as the widget in Liquid, so a block
                    // that renders nothing (Judge.me's trust badge put here
                    // instead of its Review Widget, or the app switched off)
                    // would swap the reviews for an empty panel. Without
                    // rendered app content the button goes and the theme's
                    // reviews stay.
                    const hasWidget = [...this.panel.querySelectorAll('.shopify-app-block')].some(
                        (block) => block.children.length > 0,
                    );
                    if (!hasWidget && this.panel.hidden) {
                        this.button.hidden = true;
                        return;
                    }

                    this.onClick = this.onClick.bind(this);
                    this.button.addEventListener('click', this.onClick);
                }

                disconnectedCallback() {
                    this.button?.removeEventListener('click', this.onClick);
                }

                onClick() {
                    if (this.staticReviews) this.staticReviews.hidden = true;
                    this.panel.hidden = false;
                    this.button.setAttribute('aria-expanded', 'true');
                    this.button.hidden = true;
                    this.panel.scrollIntoView({ block: 'start' });
                    this.panel.focus({ preventScroll: true });
                }
            },
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
    // Swaps in the recommended version of the slider. Shopify fills the
    // `recommendations` object only for a section rendered through
    // /recommendations/products, so the page fetches that once and replaces
    // the section's content when it came back with products.
    if (!customElements.get('product-recommendations')) {
        customElements.define(
            'product-recommendations',
            class extends HTMLElement {
                connectedCallback() {
                    this.controller = new AbortController();
                    this.load();
                }

                disconnectedCallback() {
                    this.controller?.abort();
                }

                async load() {
                    const target = document.querySelector(this.dataset.target);
                    if (!target || !this.dataset.url) return;
                    try {
                        const response = await fetch(this.dataset.url, {
                            signal: this.controller.signal,
                        });
                        if (!response.ok) return;
                        const html = new DOMParser().parseFromString(
                            await response.text(),
                            'text/html',
                        );
                        const fresh = html.querySelector(this.dataset.target);
                        if (fresh && fresh.querySelector('.splide__slide')) {
                            target.replaceWith(fresh);
                        } else if (!target.querySelector('.splide__slide')) {
                            // No recommendations and no fallback: drop the
                            // heading rather than leave it over nothing.
                            target.remove();
                        }
                    } catch (error) {
                        if (error.name !== 'AbortError') console.error(error);
                    }
                }
            },
        );
    }

  } catch(e) { console.error(e); }
})();
})();
